import {
	type IconDefinition,
	faCircle as faCircleDuoTone,
	faDiamond,
	// faHexagon,
	// faRectangleWide,
	faSquare,
	faTriangle,
} from '@fortawesome/pro-duotone-svg-icons';
import {
	type PillShape,
	PILL_SHAPE,
} from './constants';


export const PILL_SHAPE_ICONS: Partial<Record<PillShape, IconDefinition>> = {
	[PILL_SHAPE.CIRCLE]: faCircleDuoTone,
	[PILL_SHAPE.SQUARE]: faSquare,
	[PILL_SHAPE.DIAMOND]: faDiamond,
	[PILL_SHAPE.TRIANGLE]: faTriangle,
};
